// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-layout-flex-container {
   position: relative;
   display: flex;
   flex-direction: column;
   width: 100%;
   height: 100%;
   z-index: 0;
}


.main-layout-flex-container main.main-router-main {
   height: calc(100% - 60px);
   overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/routers/MainRouter.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,aAAa;GACb,sBAAsB;GACtB,WAAW;GACX,YAAY;GACZ,UAAU;AACb;;;AAGA;GACG,yBAAyB;GACzB,cAAc;AACjB","sourcesContent":[".main-layout-flex-container {\r\n   position: relative;\r\n   display: flex;\r\n   flex-direction: column;\r\n   width: 100%;\r\n   height: 100%;\r\n   z-index: 0;\r\n}\r\n\r\n\r\n.main-layout-flex-container main.main-router-main {\r\n   height: calc(100% - 60px);\r\n   overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
